export default __webpack_public_path__ + "static/media/Money Plant.a860d55b.png";